module.exports = __webpack_public_path__ + "img/UTREDF-2.0a08729e.jpg";